/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BridgeApiUpdateConversationConclusion
 */
export interface BridgeApiUpdateConversationConclusion {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiUpdateConversationConclusion
     */
    content: string;
}

/**
 * Check if a given object implements the BridgeApiUpdateConversationConclusion interface.
 */
export function instanceOfBridgeApiUpdateConversationConclusion(value: object): value is BridgeApiUpdateConversationConclusion {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function BridgeApiUpdateConversationConclusionFromJSON(json: any): BridgeApiUpdateConversationConclusion {
    return BridgeApiUpdateConversationConclusionFromJSONTyped(json, false);
}

export function BridgeApiUpdateConversationConclusionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiUpdateConversationConclusion {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function BridgeApiUpdateConversationConclusionToJSON(json: any): BridgeApiUpdateConversationConclusion {
    return BridgeApiUpdateConversationConclusionToJSONTyped(json, false);
}

export function BridgeApiUpdateConversationConclusionToJSONTyped(value?: BridgeApiUpdateConversationConclusion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

